window.addEventListener("load", function() {
    $(document).ready(function(){

        $(document).ready(function() {
            $('.intolerancies').select2();
            $('.opcions_veganes').select2({allowClear: true, placeholder: 'Selecciona una opció'});
        });

        //Formulari de compra
        $('body').on('click', '.increment', function(e) {
            e.preventDefault();
            var productId = $(this).data('productid');
            var unitatsField = $('span[data-field="unitats"][data-productid="' + productId + '"]');
            var unitatsInput = $('input[data-field="unitats"][data-productid="' + productId + '"]');
            var currentValue = parseInt(unitatsField.text());
            var newValue = currentValue + 1;
            unitatsField.text(newValue);
            unitatsInput.val(newValue);
            updateImport(productId);
        });
        $('body').on('click', '.decrement', function(e) {
            e.preventDefault();
            var productId = $(this).data('productid');
            var unitatsField = $('span[data-field="unitats"][data-productid="' + productId + '"]');
            var unitatsInput = $('input[data-field="unitats"][data-productid="' + productId + '"]');
            var currentValue = parseInt(unitatsField.text());
            var newValue = currentValue - 1;
            if(newValue >= 1) {
                unitatsField.text(newValue);
                unitatsInput.val(newValue);
                updateImport(productId);
            } else {
                //TODO: Avisar
            }
        });

        $('body').on('change', '.customImport', function(e) {
            var newImport = parseFloat($(this).val());
            var totalFormatted = newImport.toFixed(2);
            var productId = $(this).data('productid');
            $('input[data-field="import"][data-productid="' + productId + '"]').val(totalFormatted);
            $('input[data-field="import_total"]').val(totalFormatted);
            $('span[data-field="import_total"]').text(totalFormatted);
        });

        calculateTotal();

        //Formulari de registre d'usuaris
        $(document).on('click', '[data-code="dades_uniques"] input[type="checkbox"]', function() {
            var dadesUniques = $(this).is(':checked');
            if(dadesUniques){
                // Copiem tots els camps inicialment
                actualitzarCampEmpresa('nom');
                actualitzarCampEmpresa('dni', $('[data-code="dni"] input[type="text"]').val() || '');
                actualitzarCampEmpresa('adresa', $('[data-code="adresa"] input[type="text"]').val() || '');
                actualitzarCampEmpresa('cp', $('[data-code="cp"] input[type="text"]').val() || '');
                actualitzarCampEmpresa('localitat', $('[data-code="localitat"] input[type="text"]').val() || '');
            } else {
                netejarDadesEmpresa();
            }
        });

        // Esdeveniment per canviar els camps d’origen només si checkbox està marcat
        $(document).on('input change', '[data-code="nom"] input[type="text"], [data-code="cognoms"] input[type="text"], [data-code="dni"] input[type="text"], [data-code="adresa"] input[type="text"], [data-code="cp"] input[type="text"], [data-code="localitat"] input[type="text"]', function(esdeveniment) {
            if ($('[data-code="dades_uniques"] input[type="checkbox"]').is(':checked')) {
                var codi = $(this).closest('[data-code]').data('code');  // 'nom', 'cognoms', etc.
                var valor = $(this).val() || '';
                actualitzarCampEmpresa(codi, valor);
            }
        });


        //Validació de contrasenya
        $.validator.addMethod("mateixaContrasenya", function(value, element) {
            return value === $('#contrasenya').val();
        }, "Les contrasenyes no coincideixen");

    });

    // Funció per calcular el subtotal d'un producte de la compra
    function updateImport(productId) {
        var unitats = parseInt($('span[data-field="unitats"][data-productid="' + productId + '"]').text());
        var importValue = parseFloat($('span[data-field="import"][data-productid="' + productId + '"]').text());
        var newImport = unitats * importValue;
        var totalFormatted = newImport.toFixed(0);
        $('span[data-field="subtotal"][data-productid="' + productId + '"]').text(totalFormatted);
        $('input[data-field="subtotal"][data-productid="' + productId + '"]').val(totalFormatted);
        calculateTotal();
    }

    // Funció per calcular el total d'una compra
    function calculateTotal() {
        if ( $(".customImport").length ) {
            var newImport = parseFloat($(".customImport").val());
            var totalFormatted = newImport.toFixed(0);
            var productId = $(".customImport").data('productid');
            $('input[data-field="import_total"]').val(totalFormatted);
            $('span[data-field="import_total"]').text(totalFormatted);
            $('input[data-field="import"][data-productid="' + productId + '"]').val(totalFormatted);
        } else {
            var total = 0;
            $('span[data-field="subtotal"]').each(function() {
                total += parseFloat($(this).text());
            });
            var totalFormatted = total.toFixed(0);
            $('input[data-field="import_total"]').val(totalFormatted);
            $('span[data-field="import_total"]').text(totalFormatted);
        }
    }

    // Funció per posar valor i readonly en un camp d'empresa concret
    function actualitzarCampEmpresa(codiOrigen, valor) {
        var campEmpresa = '';

        switch(codiOrigen) {
            case 'nom':
            case 'cognoms':
                // Aquí cal combinar nom + cognoms
                var nom = $('[data-code="nom"] input[type="text"]').val() || '';
                var cognoms = $('[data-code="cognoms"] input[type="text"]').val() || '';
                campEmpresa = nom + ' ' + cognoms;
                $('[data-code="nom_empresa"] input[type="text"]').val(campEmpresa).prop('readonly', true);
                return; // sortim perquè hem actualitzat ja el camp nom_empresa

            case 'dni':
                campEmpresa = valor;
                $('[data-code="cif_empresa"] input[type="text"]').val(campEmpresa).prop('readonly', true);
                break;

            case 'adresa':
                campEmpresa = valor;
                $('[data-code="adresa_empresa"] input[type="text"]').val(campEmpresa).prop('readonly', true);
                break;

            case 'cp':
                campEmpresa = valor;
                $('[data-code="cp_empresa"] input[type="text"]').val(campEmpresa).prop('readonly', true);
                break;

            case 'localitat':
                campEmpresa = valor;
                $('[data-code="localitat_empresa"] input[type="text"]').val(campEmpresa).prop('readonly', true);
                break;
        }
    }

    // Funció per netejar valors i eliminar readonly
    function netejarDadesEmpresa() {
        $('[data-code="nom_empresa"] input[type="text"]').val('').prop('readonly', false);
        $('[data-code="cif_empresa"] input[type="text"]').val('').prop('readonly', false);
        $('[data-code="adresa_empresa"] input[type="text"]').val('').prop('readonly', false);
        $('[data-code="cp_empresa"] input[type="text"]').val('').prop('readonly', false);
        $('[data-code="localitat_empresa"] input[type="text"]').val('').prop('readonly', false);
    }
});
